import { Section, SectionProps } from '@cmg/design-system';
import React from 'react';

export type IndicationSectionProps = {
  sectionProps?: Omit<SectionProps, 'title' | 'data-testid'>;
};

export const IndicationSection: React.FC<React.PropsWithChildren<IndicationSectionProps>> = ({
  children,
  sectionProps,
}) => {
  return (
    <Section {...sectionProps} data-testid="read-indication-view" title="Indication">
      {children}
    </Section>
  );
};
